import { Route, Routes } from '@angular/router';
import { roleGuard } from '../../../lib/guards/admin-role.guard';
import { permissionGuard } from '../../../lib/guards/permission.guard';
import {
  DOMAIN_PAGE_TITLES,
  ScreenLayoutConfigKey,
  SCREEN_LAYOUT_CONFIG,
} from './base/screen-layout-configs';

/**
 * Screen Layout 라우트
 *
 * - /homepage-master/layout : 통합 페이지 (전체 도메인, 검색조건으로 분기)
 * - /homepage-master/home/{domain} : 도메인 전용 페이지 (route data로 도메인 강제)
 */

const guards = [roleGuard('ADMIN_MASTER'), permissionGuard('HOME_SCREEN$READ')];

const listLoader = () =>
  import(
    './components/smart/screen-layout-list-page/screen-layout-list-page.component'
  ).then((m) => m.ScreenLayoutListPageComponent);

const detailLoader = () =>
  import(
    './components/smart/screen-layout-detail-page/screen-layout-detail-page.component'
  ).then((m) => m.ScreenLayoutDetailPageComponent);

const buildDomainRoute = (
  domain: ScreenLayoutConfigKey,
  basePath: string,
): Route => ({
  path: basePath,
  canActivate: guards,
  children: [
    { path: '', redirectTo: 'list', pathMatch: 'full' },
    {
      path: 'list',
      loadComponent: listLoader,
      data: {
        config: SCREEN_LAYOUT_CONFIG,
        forcedDomain: domain,
        title: DOMAIN_PAGE_TITLES[domain],
      },
      children: [
        {
          path: ':id',
          loadComponent: detailLoader,
          data: {
            config: SCREEN_LAYOUT_CONFIG,
            forcedDomain: domain,
            title: DOMAIN_PAGE_TITLES[domain],
          },
        },
      ],
    },
  ],
});

const DOMAIN_ROUTES: Array<{ domain: ScreenLayoutConfigKey; path: string }> = [
  { domain: 'package', path: 'homepage-master/home/package' },
  { domain: 'product', path: 'homepage-master/home/product' },
  { domain: 'booking', path: 'homepage-master/home/booking' },
  { domain: 'partners', path: 'homepage-master/home/partners' },
  { domain: 'agent', path: 'homepage-master/home/agent' },
  { domain: 'article', path: 'homepage-master/home/article' },
];

export const screenLayoutRoutes: Routes = [
  {
    path: SCREEN_LAYOUT_CONFIG.routePath,
    canActivate: guards,
    children: [
      { path: '', redirectTo: 'list', pathMatch: 'full' },
      {
        path: 'list',
        loadComponent: listLoader,
        data: {
          config: SCREEN_LAYOUT_CONFIG,
          title: 'Layout Management',
        },
        children: [
          {
            path: ':id',
            loadComponent: detailLoader,
            data: {
              config: SCREEN_LAYOUT_CONFIG,
              title: 'Layout Management Detail',
            },
          },
        ],
      },
    ],
  },
  ...DOMAIN_ROUTES.map(({ domain, path }) => buildDomainRoute(domain, path)),
];
